@use "../../../globals/settings";
@use "../../../globals/bcp";

$self: ".m-language-selector";

.m-language-selector {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  &__part1 {
    display: flex;
    align-items: center;
  }

  f-link {
    @include bcp.set-css-var(link, color, settings.$text-color);
    @include bcp.set-css-var(link-hover, color, settings.$text-color);
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
